import React from 'react';
import injectSheet from 'react-jss';
import ErgoButton from './ergo-elements/components/Button';
import { DKVLightGrey, fontLarge } from '../constants';
import I18n from '../i18n';

const buttonStyles = {
  buttonStyles: {
    fontSize: ({ fontSize }) => `${fontSize ? fontSize : fontLarge} !important`,
    padding: '0.7rem 0 !important',
    borderLeft: `1px solid ${DKVLightGrey} !important`,
    minWidth: '50px !important',
    '&:focus': {
      outline: 'none'
    },
    '& .ee_button__icon--left': {
      fontSize: props => props.iconSize || 24,
      left: '15px'
    },
    '& span': {
      marginLeft: ({ icon }) => (icon ? '50px' : '20px'),
      marginRight: '20px'
    }
  }
};

export const Button = injectSheet(buttonStyles)(
  ({ classes, onClick, keys, icon, ...props }) => (
    <ErgoButton
      className={classes.buttonStyles}
      onClick={onClick}
      iconLeft={icon}
      {...props}
    >
      <I18n keys={keys} />
    </ErgoButton>
  )
);
